import { _ as D } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import { _ as v } from "./taggedTemplateLiteralLoose-b7a1029e.js";
import "./es.symbol.description-6025a604.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.assign-7e79fd7b.js";
import "./es.string.link-fd2676c6.js";
import { QUERIES as c } from "@ucl/shared-component-foundations";
import { c as T } from "./index-8b07dec9.js";
import y, { useMemo as w } from "react";
import I, { css as g, styled as _ } from "styled-components";
import "./es.object.keys-9d66766f.js";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import { _ as A } from "./cloneSlots-622cf8c9.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as H } from "./getMetrics-953aa4f8.js";
import "./web.set-timeout-72b6430f.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import { useSlots as C } from "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import { Button as F } from "./button.js";
import { Disclosures as q } from "./disclosure.js";
import { a as S } from "./index-5d0f31c6.js";
import { Link as $ } from "./link.js";
import { e as k, f as B } from "./index-f5b44da3.js";
import { c as P } from "./childrenCountCheck-bbe924c6.js";
import { hTag as Q } from "./hTag.js";
import { Text as X } from "./text.js";
import { jsxs as b, Fragment as J, jsx as a } from "react/jsx-runtime";
import "./export-cdcbfb2b.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./array-slice-79f93c56.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./iterate-13ada9e5.js";
import "./array-iteration-759bfbfa.js";
import "./function-apply-4756dee6.js";
import "./create-property-f9780ed1.js";
import "./string-html-forced-a746405b.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./es.array.is-array-7a29277f.js";
import "./array-method-is-strict-e5a3c878.js";
import "./environment-ddee5959.js";
import "./validate-arguments-length-eb516e5b.js";
import "./getTarget-19e0f923.js";
import "./useEventListener.js";
import "./isClient-2f5bedbd.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
import "./combineRefs-c9ad2c39.js";
import "./an-instance-6efcfd6c.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./inherit-if-required-f068457b.js";
import "./set-species-5ede2ed0.js";
import "./es.string.iterator-5de8a61e.js";
import "@ucl/shared-icons";
import "./es.string.starts-with-a6645e0a.js";
import "./aria.js";
import "./objectDestructuringEmpty-69c165c0.js";
import "./es.regexp.constructor-6da4b85c.js";
import "./es.regexp.to-string-e800d529.js";
import "./es.string.search-d27ec57a.js";
import "./es.string.trim-6e13db75.js";
import "./string-trim-14e37ad3.js";
import "./es.function.bind-b4bdcd4b.js";
import "./es.array.from-fe752fa6.js";
import "./es.function.name-b230e7d4.js";
import "./es.date.to-string-6ed49878.js";
import "./es.parse-float-020a2ae0.js";
import "@ucl/ucl-translation";
import "react-dom";
import "./useWindowSize.js";
import "./helperText.js";
import "./es.array.join-c1bca812.js";
import "./uniqueId.js";
import "./es.global-this-a7f40ce1.js";
import "./image.js";
import "./aspectRatio.js";
import "./species-constructor-00346775.js";
import "./mediaDisclosureButton.js";
import "./es.parse-int-d7709701.js";
import "./label.js";
import "./popupTip-06ee114c.js";
import "./usePopoverIndex.js";
import "./divider.js";
import "./focusTrap.js";
import "./es.array.find-index-cbf7640b.js";
import "./es.array.index-of-084b82ab.js";
import "./useClient.js";
import "./useOnClickOutside.js";
import "./closeButton.js";
import "./iconButton.js";
import "./getElementPosition-8d0dbc61.js";
import "./tooltip.js";
import "./carousel.js";
import "./useMediaQuery.js";
import "./index-f2264f1e.js";
import "./screenReaderOnly.js";
import "./accessibility.js";
import "./badge.js";
import "./es.string.small-23219181.js";
var K = function() {
  return ` 
  margin-block-start: unset;
  margin-block-end: unset;
  margin-inline-start: unset;
  margin-inline-end: unset;`;
}, Y = /* @__PURE__ */ I.span.withConfig({
  displayName: "globalItems__TitleWrapper",
  componentId: "sc-1k90jo8-0"
})(["&.GlobalAttributeBar__title{", ";}"], function(t) {
  var r = t.theme.components.globalAttributeBar;
  return g(r.TitleWrapper);
}), Z = /* @__PURE__ */ I(Q).withConfig({
  displayName: "globalItems__ValueWrapper",
  componentId: "sc-1k90jo8-1"
})(["&.GlobalAttributeBar__value{", ";}"], function(t) {
  var r = t.theme.components.globalAttributeBar;
  return g(r.ValueWrapper);
}), tt = /* @__PURE__ */ I.span.withConfig({
  displayName: "globalItems__DescriptionContainer",
  componentId: "sc-1k90jo8-2"
})(["&.GlobalAttributeBar__description_container{", ";}"], function(t) {
  var r = t.theme.components.globalAttributeBar;
  return g(r.DescriptionContainer);
}), rt = /* @__PURE__ */ I(X.P).withConfig({
  displayName: "globalItems__DescriptionWrapper",
  componentId: "sc-1k90jo8-3"
})(["", " &.GlobalAttributeBar__description_wrapper{", ";}"], K(), function(t) {
  var r = t.theme.components.globalAttributeBar;
  return g(r.DescriptionWrapper);
}), et = ["$enableButton"], nt = ["$enableButton"], N, j, U, L, ot = 5, it = _.div(N || (N = v([`
  `, `;
  background-color: `, `;
  display: `, `;
  flex-direction: `, `;
  border: `, `;
  box-sizing: `, `;

  @media `, ` {
    flex-direction: `, `;
    min-height: `, `;
  }
  @media `, ` {
    min-height: `, `;
  }
`])), function(t) {
  var r = t.theme.componentStyles;
  return g(r);
}, function(t) {
  return t.theme.components.globalAttributeBar.GlobalWrapper.backgroundColor;
}, function(t) {
  return t.theme.components.globalAttributeBar.GlobalWrapper.display;
}, function(t) {
  return t.theme.components.globalAttributeBar.GlobalWrapper.flexDirection;
}, function(t) {
  return t.theme.components.globalAttributeBar.GlobalWrapper.border;
}, function(t) {
  return t.theme.components.globalAttributeBar.GlobalWrapper.boxSizing;
}, c.laptopAndUp, function(t) {
  return t.theme.components.globalAttributeBar.GlobalWrapper.laptopAndUp.flexDirection;
}, function(t) {
  return t.theme.components.globalAttributeBar.GlobalWrapper.laptopAndUp.minHeight;
}, c.desktopAndUp, function(t) {
  return t.theme.components.globalAttributeBar.GlobalWrapper.desktopAndUp.minHeight;
}), at = _.div(j || (j = v([`
  padding: `, `;
  display: `, `;
  align-items: `, `;
  justify-content: `, `;
  flex-direction: `, `;
  &:not(:first-child) {
    border-top: `, `;
  }
  word-break: `, `;
  @media `, ` {
    width: `, `;
    padding: `, `;
    &:not(:first-child) {
      border-top: `, `;
      border-left: `, `;
    }
  }
  @media `, ` {
    padding: `, `;
  }
`])), function(t) {
  return t.theme.components.globalAttributeBar.ItemWrapper.padding;
}, function(t) {
  return t.theme.components.globalAttributeBar.ItemWrapper.display;
}, function(t) {
  var r = t.$enableButton, e = D(t, et);
  return r ? e.theme.components.globalAttributeBar.ItemWrapper.alignItems.enableButton : e.theme.components.globalAttributeBar.ItemWrapper.alignItems.default;
}, function(t) {
  var r = t.$enableButton, e = D(t, nt);
  return r ? e.theme.components.globalAttributeBar.ItemWrapper.justifyContent.enableButton : e.theme.components.globalAttributeBar.ItemWrapper.justifyContent.default;
}, function(t) {
  return t.theme.components.globalAttributeBar.ItemWrapper.flexDirection;
}, function(t) {
  return t.theme.components.globalAttributeBar.ItemWrapper.borderTop;
}, function(t) {
  return t.theme.components.globalAttributeBar.ItemWrapper.wordBreak;
}, c.laptopAndUp, function(t) {
  return t.theme.components.globalAttributeBar.ItemWrapper.laptopAndUp.width;
}, function(t) {
  return t.theme.components.globalAttributeBar.ItemWrapper.laptopAndUp.padding;
}, function(t) {
  return t.theme.components.globalAttributeBar.ItemWrapper.laptopAndUp.borderTop;
}, function(t) {
  return t.theme.components.globalAttributeBar.ItemWrapper.laptopAndUp.borderLeft;
}, c.desktopAndUp, function(t) {
  return t.theme.components.globalAttributeBar.ItemWrapper.desktopAndUp.padding;
}), O = _.div(U || (U = v([`
  display: `, `;
  align-items: `, `;
  flex-direction: `, `;
  gap: `, `;
  width: `, `;
  && > a {
    font-family: `, `;
    font-size: `, `;
    font-weight: `, `;
    line-height: `, `;
  }
`])), function(t) {
  return t.theme.components.globalAttributeBar.ItemInnerWrapper.display;
}, function(t) {
  return t.theme.components.globalAttributeBar.ItemInnerWrapper.alignItems;
}, function(t) {
  return t.theme.components.globalAttributeBar.ItemInnerWrapper.flexDirection;
}, function(t) {
  return t.theme.components.globalAttributeBar.ItemInnerWrapper.gap;
}, function(t) {
  return t.theme.components.globalAttributeBar.ItemInnerWrapper.width;
}, function(t) {
  return t.theme.components.globalAttributeBar.ItemInnerWrapper.a.fontFamily;
}, function(t) {
  return t.theme.components.globalAttributeBar.ItemInnerWrapper.a.fontSize;
}, function(t) {
  return t.theme.components.globalAttributeBar.ItemInnerWrapper.a.fontWeight;
}, function(t) {
  return t.theme.components.globalAttributeBar.ItemInnerWrapper.a.lineHeight;
}), pt = _(O)(L || (L = v([`
  @media `, ` {
    gap: `, `;
  }
`])), c.laptopAndUp, function(t) {
  return t.theme.components.globalAttributeBar.ItemDataWrapper.laptopAndUp.gap;
}), lt = function(r) {
  var e = r.children, o = H({
    label: "GlobalAttributesBar"
  }), m = function() {
    return y.Children.map(e, function(p, n) {
      return p && /* @__PURE__ */ y.isValidElement(p) && p.type === l ? /* @__PURE__ */ y.cloneElement(p, Object.assign({}, {
        key: n
      })) : null;
    });
  };
  return /* @__PURE__ */ b(J, {
    children: [P({
      children: e,
      componentName: "GlobalAttributeBar",
      maxChildren: ot
    }), /* @__PURE__ */ b(it, Object.assign({}, o, {
      children: [" ", m()]
    }))]
  });
}, l = function(r) {
  var e = r.children, o = r.enableButton, m = r.onClick, s = r.buttonLabel, p = s === void 0 ? "Button" : s, n = r.disclosures, i = C(e, {
    title: z,
    value: V,
    description: d,
    tags: k,
    tagGroup: B,
    link: $
  }), x = w(function() {
    var f = A(i.tags, function(u, G) {
      return /* @__PURE__ */ a(k, Object.assign({}, u, {
        className: T(["GlobalAttributeBar__Tag", u.className])
      }), G);
    }), W = A(i.tagGroup.at(-1), function(u) {
      return /* @__PURE__ */ a(B, Object.assign({}, u, {
        className: T(["GlobalAttributeBar__TagGroup", u.className]),
        _maxTagCount: 5
      }));
    }), R = A(i.description.at(-1), function(u) {
      var G = u.children;
      return /* @__PURE__ */ a(d, {
        children: G
      });
    }), h;
    return f.length > 1 && !W ? h = /* @__PURE__ */ a(B, {
      className: "GlobalAttributeBar__TagGroup",
      visibleTags: 5,
      _maxTagCount: 5,
      children: f
    }) : f.length === 1 && !W ? h = f : h = W, {
      tags: h,
      description: R
    };
  }, [i]), M = x.tags, E = x.description;
  return /* @__PURE__ */ a(at, {
    $enableButton: o,
    children: o ? /* @__PURE__ */ a(F, {
      size: "small",
      variant: "primary",
      onClick: m,
      children: p
    }) : /* @__PURE__ */ b(O, {
      children: [M, (i.title || i.value) && /* @__PURE__ */ b(pt, {
        children: [i.title, i.value]
      }), E, i.link, n && /* @__PURE__ */ a(q, {
        disclosureContent: n == null ? void 0 : n.disclosureContent,
        id: n == null ? void 0 : n.id,
        className: n == null ? void 0 : n.className,
        disclosureTitleColor: n == null ? void 0 : n.disclosureTitleColor,
        style: n == null ? void 0 : n.style
      })]
    })
  });
}, z = function(r) {
  var e = r.children;
  return /* @__PURE__ */ a(Y, {
    className: "GlobalAttributeBar__title",
    children: e
  });
}, V = function(r) {
  var e = r.children, o = r.headingLevel, m = o === void 0 ? "h2" : o;
  return /* @__PURE__ */ a(Z, {
    className: "GlobalAttributeBar__value",
    as: m,
    children: e
  });
}, d = function(r) {
  var e = r.children, o = C(e, {
    icon: d.Icon
  }, C.PickType.LAST), m = w(function() {
    var p = A(o.icon, function(n, i) {
      return /* @__PURE__ */ a(S, Object.assign({}, n, {
        size: "xxs",
        className: T(["GlobalAttributeBar__Icon", n.className])
      }), i);
    });
    return {
      icons: p
    };
  }, [o.icon]), s = m.icons;
  return /* @__PURE__ */ b(tt, {
    className: "GlobalAttributeBar__description_container",
    children: [s, /* @__PURE__ */ a(rt, {
      className: "GlobalAttributeBar__description_wrapper",
      size: "small",
      children: o.rest
    })]
  });
};
lt.ItemContainer = l;
l.Tag = k;
l.TagGroup = B;
l.Title = z;
l.Description = d;
d.Icon = S;
l.Value = V;
l.Link = $;
export {
  lt as GlobalAttributeBar
};
